import React from 'react';
import BravoBreadcrumb from '../../../../components/BravoBreadcrumb';

export default function Breadcrumb() {
  const breadcrumb = [
    {
      text: 'Home',
      url: '/'
    },
    {
      text: 'News',
      url: '/news/'
    }
  ];
  return (
    <div className="news-breadcrumb">
      <BravoBreadcrumb breadcrumb={breadcrumb} />
    </div>
  );
}
